document.addEventListener('DOMContentLoaded', () => {
    // Récupère tous les blocks quiz de la page
    const allQuiz = document.querySelectorAll(".wp-block-ws-library-ws-quiz");
    let inPause = false;
    let slide = 0;
    let score = 0;
    if (allQuiz) {
        // Passage sur tous les blocks quiz
        allQuiz.forEach(element => {
            // Récupération du wrapper principal du bloc afin d'intéragir avec ces éléments enfant
            const quizWrapper = element.querySelector('.quiz-wrapper');

            if (quizWrapper) {
                //Récupération de tous les éléments redondant
                const btnQuiz = quizWrapper.parentElement.querySelector('.quiz-button');
                const btnAnswers = quizWrapper.querySelectorAll('.answer-button');
                const btnNext = quizWrapper.querySelector('.next-button');
                const btnClose = quizWrapper.querySelector('.close-button');
                const explanation = quizWrapper.querySelector('.quiz-explanation');
                const pictoItems = quizWrapper.querySelectorAll('.picto-item');
                const quizItems = quizWrapper.querySelectorAll('.quiz-item');

                // Fonction générique pour affiché et masqué un élément (si displayMode = "flex" alors l'élement sera afficher en flexbox)
                const togleElement = (element) => {
                    element.classList.toggle('is-visible');
                }

                // Gestion de l'interation avec le bouton quiz
                btnQuiz.addEventListener('click', function () {
                    togleElement(quizWrapper);
                    togleElement(btnQuiz);
                })

                // Fonction qui permet de mettre à jour l'affichage de la liste de picto
                const updatePicto = () => {
                    pictoItems.forEach((pictoItem, index) => {
                        if (pictoItem.dataset.order === quizWrapper.dataset.slide) {
                            togleElement(pictoItem);
                        }
                    })
                }

                // Fonction qui permet de mettre à jour l'affichage de la liste de d'élément de quiz
                const updateQuizItems = () => {
                    quizItems.forEach((quizItem, index) => {
                        if (index === parseInt(quizWrapper.dataset.slide)) {
                            togleElement(quizItem);
                            togleElement(quizItem.querySelector('.list-content'));
                        }
                        else if (index === (parseInt(quizWrapper.dataset.slide) - 1)) {
                            togleElement(quizItem);
                            togleElement(quizItem.querySelector('.list-content'));
                        }
                    })
                }

                // Fonction de remise à zero l'avancé du quiz
                const resetQuiz = () => {
                    pictoItems.forEach(pictoItem => {
                        togleElement(pictoItem);
                    })
                    togleElement(pictoItems[0]);
                    togleElement(quizItems[0]);
                    togleElement(quizItems[0].querySelector('.list-content'));
                    quizWrapper.dataset.slide = 0;
                    slide = 0;
                }

                // Fonction de remise à zero les classes de tous les boutons answer
                const resetAnswersButtons = () => {
                    btnAnswers.forEach((btnAnswer) => {
                        btnAnswer.classList.remove('correct-answer');
                        btnAnswer.classList.remove('false-answer');
                    })
                }

                // Fonction d'apelle des fonctions nécessaire à la fin de quiz
                const endOfQuiz = () => {
                    if (quizWrapper.dataset.slide >= quizItems.length) {
                        resetQuiz();
                        togleElement(quizWrapper);
                        togleElement(btnQuiz);
                    }
                }

                // Fonction de gestion du passage à la slide suivante
                const nextSlide = () => {
                    slide++;
                    quizWrapper.dataset.slide = slide;
                    updatePicto();
                    updateQuizItems();
                    resetAnswersButtons();
                    endOfQuiz();
                }

                // Gestion du click sur le bouton suivant
                btnNext.addEventListener('click', function () {
                    togleElement(btnNext);
                    inPause = false;
                    nextSlide();
                })

                // Gestion du click sur le bouton de fermeture
                btnClose.addEventListener('click', function () {
                    togleElement(quizWrapper);
                    togleElement(btnQuiz);
                })

                // Gestion du click sur tous les boutons answer
                element.addEventListener('click', function (e) {

                    const btnAnswer = e.target.closest('.answer-button');
                    if (btnAnswer) {
                        if (!inPause) {
                            const state = btnAnswer.dataset.state;
                            if (state == "true") {
                                score++;
                            }
                            btnAnswer.classList.add('click-answer')
                            btnAnswers.forEach((item) => {
                                if (item.dataset.state == "true") {
                                    item.classList.add('correct-answer');
                                } else {
                                    item.classList.add('false-answer');
                                }
                            })

                            togleElement(btnNext);
                            togleElement(explanation);
                        }

                        inPause = true
                    }
                })
            }

        })
    }
})